module.exports = __webpack_public_path__ + "static/media/h2.036da260.svg";